import { useState, useEffect } from 'react';

import { Button, Card, Form, Row, Col } from 'react-bootstrap';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { checkRequired } from 'utils/validationUtils';
import TextComponent from 'components/Input/TextComponent';
import { useRestApi } from 'context/RestApiContext';
import { MessageModal } from 'components/modal/MessageModal';

import { useMaster } from 'context/MasterContext';

import { VisitType, VisitReason } from 'constants/constants';

function ConstructionProgressEditModal(props) {
  const restApi = useRestApi();
  // マスタ情報
  const master = useMaster();
  // 工事情報
  const [construction, setConstruction] = useState({});

  // 確認ダイアログ
  const [dialog, setDialog] = useState({});
  // エラーフィールド
  const [errorFileds, setErrorFileds] = useState([]);

  // モーダルの表示
  const [show, setShow] = useState(false);

  // モーダルパラメタの変更処理
  useEffect(() => {
    if (props?.params?.constructionData) {
      const src = props.params.constructionData;

      const updatedData = {
        ...src,
        ZEINUKI_KIN: src.ZEINUKI_KIN == null ? 0 : src.ZEINUKI_KIN,
        SEIKYU_KINGAKU: src.SEIKYU_KINGAKU == null ? 0 : src.SEIKYU_KINGAKU,
        FINAL_AMOUNT:
          (src.ZEINUKI_KIN == null ? 0 : src.ZEINUKI_KIN) +
          (src.SEIKYU_KINGAKU == null ? 0 : src.SEIKYU_KINGAKU),
      };

      setConstruction(updatedData);
      setShow(true);
    }
  }, [props.params]);

  // 編集処理
  const handleChange = (prop) => (target) => {
    let newValue = target?.value ?? target?.target?.value;
    let updatedConstruction = { ...construction };

    if (prop === 'SEIKYU_KINGAKU') {
      newValue = parseInt(newValue) || 0;
      updatedConstruction.SEIKYU_KINGAKU = newValue;
      updatedConstruction.FINAL_AMOUNT = (updatedConstruction.ZEINUKI_KIN || 0) + newValue;
    } else if (prop === 'SEIKYU_GENKA') {
      newValue = parseInt(newValue) || 0;
      updatedConstruction.SEIKYU_GENKA = newValue;
    } else if (prop === 'INSPECTION_FLG') {
      updatedConstruction[prop] = target.target.checked ? 1 : 0;
    } else {
      updatedConstruction[prop] = newValue;
    }
    if (prop === 'SEIKYU_GENKA' || prop === 'SEIKYU_KINGAKU') {
      // 原価率を計算
      const final = updatedConstruction.FINAL_AMOUNT || 0;
      const genka = updatedConstruction.SEIKYU_GENKA || 0;
      updatedConstruction.GENKA_RATE = final > 0 ? ((genka / final) * 100).toFixed(1) + '%' : '';
    }
    setConstruction(updatedConstruction);
    // エラーのクリア
    setErrorFileds([...errorFileds].filter((x) => x !== prop));
  };

  // 入力チェック
  const validate = () => {
    let errors = [];

    if (isEditableLostOrderStatus()) {
      checkRequired(construction.LOST_ORDER_DATE, '失注日', 'LOST_ORDER_DATE', errors);
    }
    if (isEditableStatus() && construction.INSPECTION_FLG === 1) {
      checkRequired(construction.HIKI_DATE, '引渡日', 'HIKI_DATE', errors);
    }
    setErrorFileds(errors.flatMap((x) => x.fields));

    return errors.map((x) => x.msg);
  };

  // 確定ボタン
  const handleFix = () => {
    var error = validate();
    if (error.length > 0) {
      setDialog({
        type: 'error',
        message: error,
      });
      return;
    }
    restApi.post(
      '/api/construction/progress',
      construction,
      (_) => {
        if (!props.params.call_list) {
          props.callbak();
        } else {
          props.params.callback(construction);
        }
        setShow(false);
      },
      true
    );
  };

  // 閉じるボタン処理
  const handleClose = () => {
    setShow(false);
  };

  const getLostOrderStatusId = () => {
    const status = master.constructionStatus.find((x) => x.name === '失注');
    return status ? status.id : null;
  };

  // 失注以降のステータスは編集可能
  const isEditableStatus = () => {
    const lostOrderId = getLostOrderStatusId();
    if (lostOrderId == null) return false;
    return construction.CONSTRUCTION_STATUS >= lostOrderId;
  };

  // 失注ステータスは編集可能
  const isEditableLostOrderStatus = () => {
    const lostOrderId = getLostOrderStatusId();
    if (lostOrderId == null) return false;
    return construction.CONSTRUCTION_STATUS == lostOrderId;
  };

  const isCoopOrKencho = (visitReasonKey) => {
    const reason = VisitReason.find((r) => r.key === visitReasonKey);
    return reason?.VisitType === VisitType.CORP || reason?.VisitType === VisitType.KENCHO;
  };

  return (
    <>
      <Dialog
        sx={{
          '& .MuiDialog-container': {
            '& .MuiPaper-root': {
              width: '100%',
              maxWidth: '780px',
            },
          },
        }}
        open={show}
        disableEnforceFocus={true}
      >
        <DialogTitle className="p-3">工事状況</DialogTitle>
        <DialogContent className="px-0 py-0 pr-0 pl-0">
          <Card className="m-0">
            <Card.Body>
              <Row className="pl-2 pt-2">
                <Col md="4">
                  <label>ステータス</label>
                </Col>
              </Row>
              <Row className="pt-1">
                <Col md="4">
                  <Form.Select
                    className="form-control"
                    value={construction?.CONSTRUCTION_STATUS}
                    onChange={handleChange('CONSTRUCTION_STATUS')}
                  >
                    {master.constructionStatus.map((x, i) => (
                      <option key={i} value={x['id']}>
                        {x['name']}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
              </Row>
              <Row className="pl-2 pt-2">
                <Col md="4">
                  <label>現場担当</label>
                </Col>
              </Row>
              <Row className="pt-1">
                <Col md="4">
                  <Form.Select
                    className="form-control"
                    value={construction?.GENBA_TAN_CD}
                    onChange={handleChange('GENBA_TAN_CD')}
                  >
                    <option value={'0'}>　</option>
                    {master.genbaStaff.map((x, i) => (
                      <option key={i} value={x['id']}>
                        {x['name']}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
                <Col md="5">
                  <label style={{ fontSize: '14pt', color: 'black' }}>
                    <input
                      className="mr-2"
                      style={{ transform: 'scale(1.5)' }}
                      type="checkbox"
                      checked={construction.INSPECTION_FLG == 1}
                      onChange={handleChange('INSPECTION_FLG')}
                      disabled={!isEditableStatus()}
                    ></input>
                    アフターパトロールの実施
                  </label>
                </Col>
              </Row>
              <Row className="pl-2 pt-2">
                <Col md="4">
                  <label>着工日</label>
                </Col>
                <Col md="4">
                  <label>引渡日</label>
                </Col>
                <Col md="4">
                  <label>失注日</label>
                </Col>
              </Row>
              <Row className="pt-1">
                <Col md="4">
                  <TextComponent
                    value={construction.KOUKI_ST_ACT}
                    onChange={handleChange('KOUKI_ST_ACT')}
                    type="date"
                    disabled={!isEditableStatus()}
                  />
                </Col>
                <Col md="4">
                  <TextComponent
                    value={construction.HIKI_DATE}
                    onChange={handleChange('HIKI_DATE')}
                    type="date"
                    disabled={!isEditableStatus()}
                    error={errorFileds.some((x) => x == 'HIKI_DATE')}
                  />
                </Col>
                <Col md="4">
                  <TextComponent
                    value={construction.LOST_ORDER_DATE}
                    onChange={handleChange('LOST_ORDER_DATE')}
                    type="date"
                    disabled={!isEditableLostOrderStatus()}
                    error={errorFileds.some((x) => x == 'LOST_ORDER_DATE')}
                  />
                </Col>
              </Row>
              <Row className="pl-2 pt-2">
                <Col md="4">
                  <label>契約金額(税抜)</label>
                </Col>
              </Row>
              <Row className="pt-1">
                <Col md="4">
                  <TextComponent
                    type="number"
                    style={{ textAlign: 'right' }}
                    value={Number(construction.ZEINUKI_KIN) || 0}
                    disabled={true}
                  ></TextComponent>
                </Col>
              </Row>
              <Row className="pl-2 pt-2">
                <Col md="4">
                  <label>金額変更(税抜)</label>
                </Col>
              </Row>
              <Row className="pt-1">
                <Col md="4">
                  <TextComponent
                    type="number"
                    style={{ textAlign: 'right' }}
                    value={Number(construction.SEIKYU_KINGAKU) || 0}
                    onChange={handleChange('SEIKYU_KINGAKU')}
                    disabled={!isEditableStatus()}
                  ></TextComponent>
                </Col>
              </Row>
              <Row className="pl-2 pt-2">
                <Col md="4">
                  <label>最終金額(税抜)</label>
                </Col>
                <Col md="4">
                  <label>原価金額(税抜)</label>
                </Col>
                <Col md="4">
                  <label>原価率</label>
                </Col>
              </Row>
              <Row className="pt-1">
                <Col md="4">
                  <TextComponent
                    type="number"
                    style={{ textAlign: 'right' }}
                    value={construction.FINAL_AMOUNT}
                    disabled={true}
                  ></TextComponent>
                </Col>
                <Col md="4">
                  <TextComponent
                    type="number"
                    style={{ textAlign: 'right' }}
                    value={Number(construction.SEIKYU_GENKA) || 0}
                    onChange={handleChange('SEIKYU_GENKA')}
                    disabled={!isEditableStatus()}
                  ></TextComponent>
                </Col>
                <Col md="4">
                  <TextComponent
                    type="text"
                    style={{ textAlign: 'right' }}
                    value={construction.GENKA_RATE}
                    onChange={handleChange('GENKA_RATE')}
                    disabled={true}
                  ></TextComponent>
                </Col>
              </Row>
              {isCoopOrKencho(construction.VISIT_REASON) && (
                <>
                  <Row className="pt-3">
                    <Col className="pr-1" md="4">
                      <b>＜コープ・県庁生協＞</b>
                    </Col>
                  </Row>
                  <Row className="pl-2 pt-1">
                    <Col md="4">
                      <label>受付No</label>
                    </Col>
                    <Col md="4">
                      <label>報告日</label>
                    </Col>
                  </Row>
                  <Row className="pt-1">
                    <Col md="4">
                      <TextComponent
                        type="numberString"
                        value={construction.REQUEST_NUMBER}
                        maxLength={8}
                        className="text-right"
                        onChange={handleChange('REQUEST_NUMBER')}
                      ></TextComponent>
                    </Col>
                    <Col md="4">
                      <TextComponent
                        value={construction.REPORT_DATE}
                        onChange={handleChange('REPORT_DATE')}
                        type="date"
                        disabled={!isEditableStatus()}
                      />
                    </Col>
                  </Row>
                </>
              )}
            </Card.Body>
          </Card>
        </DialogContent>
        <DialogActions className="p-3" style={{ justifyContent: 'space-between' }}>
          <Button variant="secondary" className="footer-button" onClick={handleClose}>
            閉じる
          </Button>
          <Button variant="primary btn-fill" className="footer-button" onClick={handleFix}>
            更新
          </Button>
        </DialogActions>
      </Dialog>
      <MessageModal dialog={dialog}></MessageModal>
    </>
  );
}

export default ConstructionProgressEditModal;
